/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './GroupAvatarQueueEmpty.style';

type Props = {
  number?: ?number,
  isFilled?: boolean,
  hasPlus?: boolean,
  variant: string,
};

const useStyles = createUseThemeStyles(styles);

const GroupAvatarQueueEmpty = ({
  number,
  isFilled,
  hasPlus,
  variant,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ isFilled, variant });
  const hasNumber = number && number > 1;

  return (
    <div className={classes.root}>
      {(hasNumber || hasPlus) && (
        <div>
          <span className={classes.plus}>+</span>
          {hasNumber && number}
        </div>
      )}
    </div>
  );
};

export default React.memo<Props>(GroupAvatarQueueEmpty);
